// Which result dialog a live table shows: a hand's result first, the last hand's included, then the game's
// once the player closed the last hand's (review 2026-10-10, C4).

import type { View } from "./view";

export type Dialog = "hand" | "game" | null;

/** `closed`: the index of the hand whose result the player closed. */
export function dialogFor(v: View, closed: number | null): Dialog {
  if (v.result?.end && closed !== (v.hand?.index ?? -1)) return "hand";
  if (v.gameEnd) return "game";
  return null;
}
